import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mt-8" }
const _hoisted_2 = { class: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 pb-6" }
const _hoisted_3 = { class: "text-muted-foreground text-sm" }
const _hoisted_4 = { class: "px-6 space-y-8" }
const _hoisted_5 = { class: "space-y-3" }
const _hoisted_6 = { class: "grid gap-2 sm:grid-cols-[repeat(4,minmax(0,1fr))] sm:items-start" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = {
  key: 0,
  class: "mt-3 flex justify-end"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex flex-wrap gap-2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "space-y-3" }
const _hoisted_19 = { class: "flex flex-col sm:flex-row gap-2" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "space-y-2 rounded-md border border-border/60 bg-white/70 p-3" }
const _hoisted_27 = { class: "flex items-center justify-between gap-2" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex flex-wrap gap-2" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "md:col-span-2"
}
const _hoisted_35 = { class: "flex flex-col gap-4 border border-border rounded-lg p-4 bg-muted/10" }
const _hoisted_36 = { class: "flex items-center justify-between gap-4" }
const _hoisted_37 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_38 = { class: "w-full" }
const _hoisted_39 = { class: "relative" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-brand"
}
const _hoisted_42 = {
  key: 0,
  class: "text-xs text-red-600 mt-1"
}
const _hoisted_43 = {
  key: 1,
  class: "text-xs text-muted-foreground mt-1"
}
const _hoisted_44 = {
  key: 0,
  class: "w-full"
}
const _hoisted_45 = { class: "w-full rounded-md border border-border bg-muted/30 px-3 py-2 text-sm text-foreground" }
const _hoisted_46 = {
  key: 3,
  class: "md:col-span-2"
}
const _hoisted_47 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_48 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_49 = {
  key: 4,
  class: "md:col-span-2"
}
const _hoisted_50 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_51 = { class: "flex justify-between items-center px-6 pt-6" }

import { computed, ref, toRef, watch } from 'vue'
import { useCompanyMarketData } from '@/composables/useCompanyMarketData'
import { getCompanyMarketCap as getRegistrationMarketCap } from '@/api/company/registration'
import GoogleMap from '@/components/marketplace/generic/GoogleMap.vue'
import IndustryAttributeFields from '@/components/marketplace/company/IndustryAttributeFields.vue'
import { useCompanyIndustryProfileStore } from '@/stores/companyIndustryProfileStore'
import { industryAttributeErrors } from '@/validation/industryAttributes'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyProfileStep',
  props: {
    data: {},
    industries: {}
  },
  emits: ['update', 'next', 'back'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const toSafeString = (value: unknown): string => (typeof value === 'string' ? value : '').trim()
const isDecimalString = (value: string): boolean => /^\d+(?:\.\d+)?$/.test(value)
const normalizeDecimalInput = (value: unknown): string => {
  const raw = String(value ?? '').replace(/[^\d.]/g, '')
  const [whole = '', ...decimalParts] = raw.split('.')
  if (decimalParts.length === 0) return whole
  return `${whole}.${decimalParts.join('')}`
}
const splitLegacyName = (value: unknown) => {
  const fullName = toSafeString(value)
  if (!fullName) return { firstName: '', lastName: '' }
  const parts = fullName.split(/\s+/)
  const firstName = parts.shift() ?? ''
  const lastName = parts.join(' ')
  return { firstName, lastName }
}

const normalizeCommoditiesList = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map((item) => toSafeString(item)).filter((item) => item !== '')
  }
  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '')
  }
  return []
}

const normalizeKeyPeople = (value: unknown) => {
  if (!Array.isArray(value) || value.length === 0) {
    return [{ firstName: '', lastName: '', role: '', roleStartDate: '' }]
  }

  return value.map((entry: any) => {
    const firstName = toSafeString(entry?.firstName)
    const lastName = toSafeString(entry?.lastName)
    const role = toSafeString(entry?.role ?? entry?.position)
    const roleStartDate = toSafeString(entry?.roleStartDate ?? entry?.role_start_date ?? entry?.startDate ?? entry?.start_date)

    if (firstName || lastName) {
      return { firstName, lastName, role, roleStartDate }
    }

    const legacy = splitLegacyName(entry?.name)
    return { firstName: legacy.firstName, lastName: legacy.lastName, role, roleStartDate }
  })
}

const normalizeKeyProjects = (value: unknown) => {
  if (!Array.isArray(value) || value.length === 0) {
    return [{
      name: '',
      stage: '',
      description: '',
      location_label: '',
      location_lat: null,
      location_lng: null,
      commodities: [],
      activity_feed: [],
    }]
  }

  return value.map((entry: any) => ({
    name: toSafeString(entry?.name),
    stage: toSafeString(entry?.stage),
    description: toSafeString(entry?.description),
    location_label: toSafeString(entry?.location_label ?? entry?.locationLabel ?? entry?.location),
    location_lat: entry?.location_lat ?? entry?.locationLat ?? entry?.lat ?? null,
    location_lng: entry?.location_lng ?? entry?.locationLng ?? entry?.lng ?? entry?.lon ?? null,
    commodities: normalizeCommoditiesList(entry?.commodities),
    activity_feed: Array.isArray(entry?.activity_feed ?? entry?.activityFeed)
      ? (entry?.activity_feed ?? entry?.activityFeed)
          .map((activity: any) => ({
            date: toSafeString(activity?.date ?? activity?.released_at ?? activity?.releasedAt),
            text: toSafeString(activity?.text ?? activity?.update ?? activity?.description),
          }))
          .filter((activity: any) => activity.date || activity.text)
      : [],
  }))
}

const localData = ref({
  ...props.data,
  keyPeople: normalizeKeyPeople((props.data as any).keyPeople),
  keyProjects: normalizeKeyProjects((props.data as any).keyProjects),
  industryAttributes: { ...((props.data as any).industryAttributes ?? {}) },
  isPrivateCompany: Boolean((props.data as any).isPrivateCompany),
  cashInBankUpdatedAt:
    (props.data as any).cashInBankUpdatedAt ?? (props.data as any).cashInBankRecordedAt ?? null,
})
const errors = ref<Record<string, string>>({})

const tickerRef = toRef(localData.value, 'companyTicker')
const marketCapRef = toRef(localData.value, 'marketCap')

const {
  isFetching: isFetchingMarketCap,
  error: marketCapError,
  onTickerInput,
  onMarketCapInput,
} = useCompanyMarketData(tickerRef, marketCapRef, {
  fetcher: async (symbol) => {
    try {
      const { data } = await getRegistrationMarketCap(symbol)
      return data
    } catch (err: any) {
      if (err?.response?.status === 404) {
        return { notFound: true }
      }
      throw err
    }
  },
})

const COMMODITIES = [
  'Aluminium',
  'Ammonia',
  'Antimony',
  'Arsenic',
  'Barium',
  'Bauxite',
  'Beryllium',
  'Bismuth',
  'Boron',
  'Caesium',
  'Calcium Carbonate',
  'Chromite',
  'Chromium',
  'Clinker',
  'Coal',
  'Cobalt',
  'Copper',
  'Diamonds',
  'Dolerite',
  'Dysprosium',
  'Feldspar',
  'Fluorine',
  'Fluorspar',
  'Gallium',
  'Garnet',
  'Germanium',
  'Gold',
  'Graphite',
  'Granite',
  'Gypsum',
  'Hafnium',
  'Halloysite',
  'Helium',
  'Hydrocarbon',
  'Hydrogen',
  'Ilmenite',
  'Indium',
  'Iridium',
  'Iron Ore',
  'Kaolin',
  'Lead',
  'Lepidolite',
  'Leucoxene',
  'Limestone',
  'Lithium',
  'LNG',
  'Magnesium',
  'Manganese',
  'Mineral Sands',
  'Monazite',
  'Molybdenum',
  'Muscovite',
  'Neodymium',
  'Nickel',
  'Niobium',
  'Nitrogen',
  'Osmium',
  'Palladium',
  'Petroleum',
  'Phosphate',
  'Phosphorus',
  'Platinum',
  'Polymetallic Nodule',
  'Potash',
  'Potassium',
  'Praseodymium',
  'Quartz',
  'Rare Earth Elements',
  'Rhenium',
  'Rhodium',
  'Rubidium',
  'Ruthenium',
  'Rutile',
  'Scandium',
  'Silica Sand',
  'Silicon',
  'Silver',
  'Sodium Chloride',
  'Strontium',
  'Sulphur',
  'Tantalite',
  'Tantalum',
  'Terbium',
  'Tellurium',
  'Thorium',
  'Tin',
  'Titanium',
  'Topaz',
  'Tungsten',
  'Uranium',
  'Urea',
  'Vanadium',
  'Volcanogenic Massive Sulfide',
  'Xenotime',
  'Zinc',
  'Zircon',
  'Zirconium',
  'Other',
]

const PROJECT_STAGES = [
  'Exploration',
  'Pre-Feasibility',
  'Feasibility',
  'Development',
  'Production',
  'Brownfield',
  'Care & Maintenance',
  'Rehabilitation and Closure'
]

const resolvedIndustryName = computed(() => {
  const industries = props.industries ?? []
  const rawValue = localData.value.industry

  if (rawValue == null || rawValue === '') return ''

  const asNumber = typeof rawValue === 'number' ? rawValue : Number(rawValue)
  if (!Number.isNaN(asNumber)) {
    const matchById = industries.find((industry) => industry.id === asNumber)
    if (matchById?.name) return matchById.name
  }

  if (typeof rawValue === 'string') {
    const trimmed = rawValue.trim()
    if (!trimmed) return ''

    const lower = trimmed.toLowerCase()
    const matchByName = industries.find((industry) => industry.name?.toLowerCase() === lower)
    if (matchByName?.name) return matchByName.name

    return trimmed
  }

  return ''
})

const shouldShowCommodities = computed(() => {
  const name = resolvedIndustryName.value.trim().toLowerCase()
  return name !== '' && name.includes('mining')
})

const industryProfileStore = useCompanyIndustryProfileStore()
const industryProfile = computed(() => industryProfileStore.resolve(resolvedIndustryName.value))

const shouldShowMarketData = computed(() => industryProfile.value?.sections.market_data ?? false)
const showKeyProjects = computed(() => industryProfile.value?.sections.key_projects ?? true)

const industryAttributeFieldErrors = computed(() => {
  const fieldErrors: Record<string, string> = {}
  for (const [key, message] of Object.entries(errors.value)) {
    if (key.startsWith('industryAttributes.')) fieldErrors[key.slice('industryAttributes.'.length)] = message
  }
  return fieldErrors
})

watch(localData, (val) => emits('update', val), { deep: true })

watch(
  () => localData.value.isPrivateCompany,
  (isPrivate) => {
    if (!isPrivate) return
    localData.value.companyTicker = ''
    localData.value.marketCap = ''
  }
)

watch(shouldShowCommodities, (show) => {
  if (show) return
  const nextErrors = { ...errors.value }
  delete nextErrors.commodities
  errors.value = nextErrors
})

watch(shouldShowMarketData, (show) => {
  if (show) return
  const nextErrors = { ...errors.value }
  delete nextErrors.marketData
  delete nextErrors.cashInBank
  delete nextErrors.cashInBankDate
  delete nextErrors.cashRunway
  errors.value = nextErrors
})

const addKeyPerson = () => localData.value.keyPeople.push({ firstName: '', lastName: '', role: '', roleStartDate: '' })
const removeKeyPerson = (index: number) => {
  localData.value.keyPeople.splice(index, 1)
  if (!localData.value.keyPeople.length)
    localData.value.keyPeople.push({ firstName: '', lastName: '', role: '', roleStartDate: '' })
}

const addKeyProject = () => localData.value.keyProjects.push({
  name: '',
  stage: '',
  description: '',
  location_label: '',
  location_lat: null,
  location_lng: null,
  commodities: [],
  activity_feed: [],
})
const removeKeyProject = (index: number) => {
  localData.value.keyProjects.splice(index, 1)
  if (!localData.value.keyProjects.length) {
    localData.value.keyProjects.push({
      name: '',
      stage: '',
      description: '',
      location_label: '',
      location_lat: null,
      location_lng: null,
      commodities: [],
      activity_feed: [],
    })
  }
}

const toggleProjectCommodity = (index: number, commodity: string) => {
  const project = localData.value.keyProjects[index]
  if (!project) return
  if (!Array.isArray(project.commodities)) {
    project.commodities = []
  }
  if (project.commodities.includes(commodity)) {
    project.commodities = project.commodities.filter((item: string) => item !== commodity)
  } else {
    project.commodities.push(commodity)
  }
}

const updateProjectLocation = (index: number, location: { lat: number; lng: number }) => {
  const project = localData.value.keyProjects[index]
  if (!project) return
  project.location_lat = location.lat
  project.location_lng = location.lng
}

const addProjectActivity = (index: number) => {
  const project = localData.value.keyProjects[index]
  if (!project) return
  if (!Array.isArray(project.activity_feed)) {
    project.activity_feed = []
  }
  project.activity_feed.push({ date: '', text: '' })
}

const removeProjectActivity = (projectIndex: number, activityIndex: number) => {
  const project = localData.value.keyProjects[projectIndex]
  if (!project || !Array.isArray(project.activity_feed)) return
  project.activity_feed.splice(activityIndex, 1)
}

const toggleCommodity = (commodity: string) => {
  if (!Array.isArray(localData.value.commodities)) {
    localData.value.commodities = []
  }
  const list = localData.value.commodities
  if (list.includes(commodity)) {
    localData.value.commodities = list.filter((c: string) => c !== commodity)
  } else {
    localData.value.commodities.push(commodity)
  }
}

const onCashInBankInput = () => {
  localData.value.cashInBankUpdatedAt = null
}

const onCashRunwayInput = () => {
  localData.value.cashRunway = normalizeDecimalInput(localData.value.cashRunway)
}

const validateAndProceed = () => {
  const newErrors: Record<string, string> = {}

  const hasCompletePerson = localData.value.keyPeople.some(
    (p: any) => toSafeString(p.firstName) && toSafeString(p.lastName) && toSafeString(p.role)
  )
  if (!hasCompletePerson) {
    newErrors.keyPeople = 'Add at least one key person with first name, last name, and role'
  }

  for (const [key, message] of Object.entries(
    industryAttributeErrors(industryProfile.value, localData.value.industryAttributes)
  )) {
    newErrors[`industryAttributes.${key}`] = message
  }

  const hasMarketData = toSafeString(localData.value.companyTicker)
  if (shouldShowCommodities.value && !localData.value.isPrivateCompany && !hasMarketData) {
    newErrors.marketData = 'Enter an exchange ticker or mark the company as private'
  }

  if (toSafeString(localData.value.cashInBank) && !toSafeString(localData.value.cashInBankUpdatedAt)) {
    newErrors.cashInBankDate = 'Date of Balance is required when cash in bank is provided'
  }

  const cashRunway = toSafeString(localData.value.cashRunway)
  if (cashRunway && !isDecimalString(cashRunway)) {
    newErrors.cashRunway = 'Cash runway must be a number or decimal'
  }

  errors.value = newErrors

  if (Object.keys(newErrors).length === 0) emits('next')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "leading-none font-semibold text-lg" }, "Company Profile", -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(showKeyProjects.value ? 'Share details about your operations and key projects' : 'Share details about your team and experience'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
          _createElementVNode("label", { class: "font-medium text-sm" }, "Key People"),
          _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(executives, managers, etc.)")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localData.value.keyPeople, (person, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "rounded-lg border border-border/60 bg-background/80 p-3 shadow-sm"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((person.firstName) = $event),
                  type: "text",
                  placeholder: "First name",
                  class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                }, null, 8, _hoisted_7), [
                  [_vModelText, person.firstName]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((person.lastName) = $event),
                  type: "text",
                  placeholder: "Last name",
                  class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                }, null, 8, _hoisted_8), [
                  [_vModelText, person.lastName]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((person.role) = $event),
                  type: "text",
                  placeholder: "Role / Job Title",
                  class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none sm:col-span-1"
                }, null, 8, _hoisted_9), [
                  [_vModelText, person.role]
                ]),
                _createVNode(_unref(VueDatePicker), {
                  modelValue: person.roleStartDate,
                  "onUpdate:modelValue": ($event: any) => ((person.roleStartDate) = $event),
                  "enable-time-picker": false,
                  "auto-apply": "",
                  teleport: "",
                  "model-type": "yyyy-MM-dd",
                  format: "dd/MM/yyyy",
                  placeholder: "Role start date",
                  "input-class": [
                  'w-full h-10 rounded-md border border-border text-foreground px-3 text-sm focus:ring-2 focus:ring-brand focus:border-brand bg-background',
                ],
                  "menu-class": ['rounded-lg shadow-lg border border-border bg-background']
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              (localData.value.keyPeople.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (removeKeyPerson(index)),
                      class: "inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-medium text-muted-foreground transition hover:border-brand hover:text-foreground",
                      type: "button"
                    }, " Remove ", 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            onClick: addKeyPerson,
            class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand"
          }, " + Add Person ")
        ]),
        (errors.value.keyPeople)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.keyPeople), 1))
          : _createCommentVNode("", true)
      ]),
      (false && shouldShowCommodities.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "font-medium text-sm mb-2 block" }, "Commodities", -1)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COMMODITIES, (commodity) => {
                return _createElementVNode("button", {
                  key: commodity,
                  type: "button",
                  onClick: ($event: any) => (toggleCommodity(commodity)),
                  class: _normalizeClass(["px-3 py-1 rounded-full border text-sm transition-colors", localData.value.commodities.includes(commodity)
              ? 'bg-brand text-white border-brand'
              : 'border-muted-foreground/30 text-muted-foreground hover:border-brand hover:text-foreground'])
                }, _toDisplayString(commodity), 11, _hoisted_15)
              }), 64))
            ]),
            (errors.value.commodities)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(errors.value.commodities), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(IndustryAttributeFields, {
        profile: industryProfile.value,
        modelValue: localData.value.industryAttributes,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData.value.industryAttributes) = $event)),
        errors: industryAttributeFieldErrors.value
      }, null, 8, ["profile", "modelValue", "errors"]),
      (showKeyProjects.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "font-medium text-sm mb-2 block" }, "Key Projects", -1)),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localData.value.keyProjects, (project, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "rounded-lg border border-border/60 bg-background/80 p-3 shadow-sm space-y-2"
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((project.name) = $event),
                      type: "text",
                      placeholder: "Project name",
                      class: "flex-1 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                    }, null, 8, _hoisted_20), [
                      [_vModelText, project.name]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((project.stage) = $event),
                      class: "w-full sm:w-48 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Stage", -1)),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PROJECT_STAGES, (stage) => {
                        return _createElementVNode("option", {
                          key: stage,
                          value: stage
                        }, _toDisplayString(stage), 9, _hoisted_22)
                      }), 64))
                    ], 8, _hoisted_21), [
                      [_vModelSelect, project.stage]
                    ]),
                    (localData.value.keyProjects.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (removeKeyProject(index)),
                          class: "border border-border rounded-md px-2 hover:bg-muted",
                          type: "button"
                        }, " ✕ ", 8, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((project.location_label) = $event),
                    type: "text",
                    placeholder: "Project location",
                    class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                  }, null, 8, _hoisted_24), [
                    [_vModelText, project.location_label]
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => ((project.description) = $event),
                    rows: "3",
                    placeholder: "Project description",
                    class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                  }, null, 8, _hoisted_25), [
                    [_vModelText, project.description]
                  ]),
                  (project.location_label)
                    ? (_openBlock(), _createBlock(GoogleMap, {
                        key: 0,
                        editable: "",
                        address: project.location_label,
                        lat: project.location_lat ?? null,
                        lng: project.location_lng ?? null,
                        "map-height-class": "h-40",
                        "onUpdate:location": ($event: any) => (updateProjectLocation(index, $event))
                      }, null, 8, ["address", "lat", "lng", "onUpdate:location"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs font-medium text-muted-foreground" }, "Activity feed", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-xs font-semibold text-brand hover:text-brand/80",
                        onClick: ($event: any) => (addProjectActivity(index))
                      }, " + Add update ", 8, _hoisted_28)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.activity_feed, (activity, activityIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: activityIndex,
                        class: "grid gap-2 sm:grid-cols-[150px,minmax(0,1fr),auto]"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((activity.date) = $event),
                          type: "date",
                          class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 8, _hoisted_29), [
                          [_vModelText, activity.date]
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((activity.text) = $event),
                          rows: "2",
                          placeholder: "Market update",
                          class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 8, _hoisted_30), [
                          [_vModelText, activity.text]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "border border-border rounded-md px-2 hover:bg-muted",
                          onClick: ($event: any) => (removeProjectActivity(index, activityIndex))
                        }, " ✕ ", 8, _hoisted_31)
                      ]))
                    }), 128))
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs font-medium text-muted-foreground" }, "Project commodities", -1)),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COMMODITIES, (commodity) => {
                      return _createElementVNode("button", {
                        key: commodity,
                        type: "button",
                        onClick: ($event: any) => (toggleProjectCommodity(index, commodity)),
                        class: _normalizeClass(["px-3 py-1 rounded-full border text-sm transition-colors", project.commodities?.includes(commodity)
                  ? 'bg-brand text-white border-brand'
                  : 'border-muted-foreground/30 text-muted-foreground hover:border-brand hover:text-foreground'])
                      }, _toDisplayString(commodity), 11, _hoisted_33)
                    }), 64))
                  ])
                ]))
              }), 128)),
              _createElementVNode("button", {
                type: "button",
                onClick: addKeyProject,
                class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand"
              }, " + Add Project ")
            ])
          ]))
        : _createCommentVNode("", true),
      (shouldShowMarketData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-medium mb-3" }, "Market Data", -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "text-sm font-medium text-foreground" }, "Private company"),
                  _createElementVNode("p", { class: "text-xs text-muted-foreground" }, " Select this if your company is not publicly listed. ")
                ], -1)),
                _createElementVNode("label", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.isPrivateCompany) = $event)),
                    type: "checkbox",
                    class: "sr-only peer"
                  }, null, 512), [
                    [_vModelCheckbox, localData.value.isPrivateCompany]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "h-6 w-11 rounded-full border border-border bg-muted/40 transition-colors peer-checked:bg-brand peer-focus-visible:ring-2 peer-focus-visible:ring-brand/40" }, null, -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5" }, null, -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-xs font-medium mb-1 text-muted-foreground" }, "ASX Ticker", -1)),
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localData.value.companyTicker) = $event)),
                    type: "text",
                    placeholder: "e.g., BHP",
                    maxlength: "5",
                    disabled: localData.value.isPrivateCompany,
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onTickerInput) && _unref(onTickerInput)(...args))),
                    class: "w-full border border-border rounded-md px-3 py-2 uppercase focus:ring-2 focus:ring-brand focus:border-transparent outline-none disabled:bg-muted/40 disabled:text-muted-foreground"
                  }, null, 40, _hoisted_40), [
                    [_vModelText, localData.value.companyTicker]
                  ]),
                  (_unref(isFetchingMarketCap))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _cache[18] || (_cache[18] = [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "10"
                        }, null, -1),
                        _createElementVNode("path", { d: "M4 12a8 8 0 018-8" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                (_unref(marketCapError))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_unref(marketCapError)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_43, " Market cap is fetched automatically from the ASX ticker. If you’re not listed, mark the company as private. "))
              ]),
              (localData.value.marketCap)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-xs font-medium mb-1 text-muted-foreground" }, "Market Cap (auto)", -1)),
                    _createElementVNode("div", _hoisted_45, _toDisplayString(localData.value.marketCap), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (shouldShowMarketData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Cash in Bank", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localData.value.cashInBank) = $event)),
              type: "text",
              placeholder: "e.g., $10M AUD",
              onInput: onCashInBankInput,
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
            }, null, 544), [
              [_vModelText, localData.value.cashInBank]
            ]),
            (toSafeString(localData.value.cashInBank))
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-xs font-medium mb-1 text-muted-foreground" }, "Date of Balance", -1)),
                  _createVNode(_unref(VueDatePicker), {
                    modelValue: localData.value.cashInBankUpdatedAt,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localData.value.cashInBankUpdatedAt) = $event)),
                    "enable-time-picker": false,
                    "auto-apply": "",
                    teleport: "",
                    "model-type": "yyyy-MM-dd",
                    format: "dd/MM/yyyy",
                    placeholder: "Select date",
                    "input-class": [
              'w-full h-10 rounded-md border border-border text-foreground px-3 text-sm focus:ring-2 focus:ring-brand focus:border-brand bg-background',
            ],
                    "menu-class": ['rounded-lg shadow-lg border border-border bg-background']
                  }, null, 8, ["modelValue"]),
                  (errors.value.cashInBankDate)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(errors.value.cashInBankDate), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (shouldShowMarketData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Cash Runway", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localData.value.cashRunway) = $event)),
              type: "text",
              inputmode: "decimal",
              placeholder: "e.g., 4 or 4.5",
              onInput: onCashRunwayInput,
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
            }, null, 544), [
              [_vModelText, localData.value.cashRunway]
            ]),
            (errors.value.cashRunway)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(errors.value.cashRunway), 1))
              : _createCommentVNode("", true),
            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-1 text-xs text-muted-foreground" }, " Estimated time (in quarters) a company can operate using current cash, based on recent spend ", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md border border-border text-sm hover:bg-muted",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('back')))
      }, " Back "),
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md bg-brand text-white text-sm hover:opacity-90",
        onClick: validateAndProceed
      }, " Next ")
    ])
  ]))
}
}

})